import {createContext,useContext} from 'solid-js';
import { theme } from 'Shared/frontend/SettingsProvider';

const PageDetailsContext = createContext();

interface IPageDetailsContent {
	pageName: string;
	setPageName: (name:string)=>void;
	setSettingsPageName: (name:string)=>void,
	setExpandDesktopNav: (expand:boolean)=>void,
	imageFolder: string;
	setImageFolder: (name:string)=>void,
}

export function PageDetailsProvider(P:{children} & IPageDetailsContent)
{
	return (
		<PageDetailsContext.Provider value={P}>
			{P.children}
		</PageDetailsContext.Provider>
	);
}

export function initPageDetails(pageName:string,settingsPageName:string,imageFolder:string|null=null)
{
	const details = useContext(PageDetailsContext);
	details.setPageName(pageName);
	details.setSettingsPageName(settingsPageName);
	details.setImageFolder(imageFolder);

	const enableShrink = theme().nav.desktop.settings.enableShrink;
	details.setExpandDesktopNav(enableShrink);
}

export function usePageDetails():IPageDetailsContent
{
	return useContext(PageDetailsContext);
}

